import { render, staticRenderFns } from "./forget.vue?vue&type=template&id=715ff2fe&scoped=true&"
import script from "./forget.vue?vue&type=script&lang=js&"
export * from "./forget.vue?vue&type=script&lang=js&"
import style0 from "./forget.vue?vue&type=style&index=0&id=715ff2fe&prod&lang=css&"
import style1 from "./forget.vue?vue&type=style&index=1&id=715ff2fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ff2fe",
  null
  
)

export default component.exports